import React from 'react';
import * as FaIcons from 'react-icons/fa';

function PasswordVisibility ({visible, onPasswordChange}){
    return (<div className="oi-form__input-visibility">
        {visible ? (
            <FaIcons.FaEye
                className="oi-form__input-show-icon"
                onClick={() => onPasswordChange()}
            />
        ) : (
            <FaIcons.FaEyeSlash
                className="oi-form__input-hide-icon"
                onClick={() => onPasswordChange()}
            />
        )}
    </div>)
}
export default PasswordVisibility;